<template>
  <div>
    <!-- <h3>
      {{ errorMessage }}
    </h3>-->

    <section class="container-fluid p-0 bodyArea">
      <div class="containerBox">
        <div class="pageHeader row align-items-center">
          <div class="col-3 pageHeaderTitle">Roles</div>
          <div class="col text-right">
            <div class="filterWrapper">
              <div class="filterText">Tenant :</div>
              <div class="dropdown col p-0">
                <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
                  placeholder="Select Tenant" @input="validateSelection" class="tenantList">
                </model-select>
                <!-- <select
                    style="background: transparent; color: #fff;  border: 0;"
                    id="tenantId"
                    v-model="lastSelectedTenant"
                    @change="changeTenantView"
                >
                  <option
                      class="tenantOption"
                      v-for="option in tenants"
                      v-bind:key="option"
                      :value="option.value"
                  >{{ option.text ? option.text : option.value }}
                  </option>
                </select> -->
              </div>
            </div>

            <div class="filterWrapper filter-wrapper-2">
              <div class="filterText">Filter:</div>
              <!-- <div class="dropdown col p-0"> -->

              <input v-model="filterString" type="text" maxlength="20" class="filterInputText" />
            </div>
            <div class="importBtn" @click.prevent="onChanged">Add Role</div>
          </div>
        </div>

        <div class="pageDataWrapper">
          <div class="contentHeader row m-0 align-items-center">
            <div class="col-4">Name</div>
            <div class="col">Description</div>
            <div class="col">Scope</div>

            <div class="col actionHeading text-center">Action</div>
          </div>

          <div class="contentDataWrapper userContentWrapper row m-0">
            <div v-if="rolesListEmpty">
            <h3>No results found</h3>
          </div>
            <div class="contentData row m-0 align-items-center col-12 p-0" v-for="role in roles.filter(function (u) {
              if (!filterString || filterString.trim().length === 0) {
                return true;
              }
              return (
                (u.name &&
                  u.name.toLowerCase().indexOf(filterString.toLowerCase()) >=
                  0) ||
                (u.permissions &&
                  u.permissions.find(
                    (e) =>
                      e.toLowerCase().indexOf(filterString.toLowerCase()) >= 0
                  ))
              );
            })" v-bind:key="role.name">
              <div class="col-4 row m-0">
                <div class="col p-0">
                  <span class="smallFont userId">{{ role.name }}</span>
                </div>
                <!-- <div class="col p-0">Consulate | PD 5311</div> -->
              </div>
              <div class="col row m-0">
                <div class="col p-0">
                  <span class="smallFont">{{ role.description }}</span>
                </div>
                <!-- <div class="col p-0 text-right">
                  <span>Phone :</span>(407)-564-6739345
                </div>-->
              </div>
              <div class="col">
                <span v-for="per in role.permissions" v-bind:key="per">{{
                  permissions.find((p) => p.value == per)
                  ? permissions.find((p) => p.value == per).text + ","
                  : ""
                }}</span>
              </div>

              <div class="col actionHeading text-center">
                <!--  <button class="buttonItem m-0" @click.prevent="onEditChanged(role)">Edit</button> -->
                <img v-on:click="
                  lastSelectedTenant !== '*' ? onEditChanged(role) : false
                  " onclick="false" src="../assets/images/edit.svg" width="16" />
                <!--  @click="(showModal = true), (deletedRole = user.userId)" -->
                <img @click="
                  lastSelectedTenant !== '*'
                    ? (showDeleteModal = true)((deletedRole = role.name))
                    : (showDeleteModal = false)
                  " src="../assets/images/delete.svg" width="16" style="margin-left: 8px" />
              </div>
              <!-- Modal Content  -->
            </div>
          </div>
        </div>
      </div>

      <b-modal id="addModal" modal-class="add-role-modal" hide-backdrop centered title="Add Roles" title-class="test" ok-title="Save" @ok="addRole"
        @hidden="addModal" @cancel="addModal">
        <b-form ref="form">
          <b-form-group label="Name" label-for="roleName" invalid-feedback="Please enter a Name.">
            <b-form-input id="roleName" v-model="roleName" placeholder="Name"></b-form-input>
          </b-form-group>
          <b-form-group label="Description" label-for="description" invalid-feedback="Please enter a description.">
            <b-form-input id="description" v-model="roleDescription" placeholder="Description"></b-form-input>
          </b-form-group>

          <b-form-group label="Tenant" label-for="tenant-input" invalid-feedback="Select Tenant">
            <b-form-select id="tenant-input" v-model="permissionSelectedTenant" @change="changepermissionTenantView" placeholder="Select Tenant">
              <option class="tenantOption" v-for="option in tenants" v-bind:key="option.value" :value="option.id">
                {{ option.text ? option.text : option.value }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group class="permissionWrapper" 
            label="Permissions"
            label-for="permissions-input"
            invalid-feedback="Please select a permission."
            >
            <treeselect 
              v-model="items" 
              :searchable="true"
              :clearable="true"
              :multiple="true" 
              :valueConsistsOf="'ALL'"
              @input="processSelection"
              :options="formattedPermissions">
              <div slot="before-list" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" style="padding: 15px; font-size: 12px; line-height: 15px; text-align: center;">
                Some permissions are shared across parents in the tree. Examples include a number of the video calling permissions and viewing patients / tasks. As a result some other nodes may partially select when selecting all of a parent branch.
              </div>
            </treeselect>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-modal id="editModal" hide-backdrop centered title="Edit Roles" ok-title="Update" @ok="updateRole"
        @hidden="editModal" @cancel="editModal">
        <b-form ref="form">
          <b-form-group label="Name" label-for="editRoleName">
            <b-form-input id="editRoleName" disabled v-model="editRoleName"></b-form-input>
          </b-form-group>
          <b-form-group label="Description" label-for="editRoleDescription">
            <b-form-input id="editRoleDescription" v-model="editRoleDescription"></b-form-input>
          </b-form-group>

          <b-form-group label="Tenant" label-for="tenant-input" invalid-feedback="Select Tenant">
            <b-form-input id="tenant-input" disabled v-model="permissionSelectedTenant"></b-form-input>
            <!--  <b-form-select id="tenant-input"  v-model="permissionSelectedTenant"
              @change="changepermissionTenantView">
              <option
                disabled
                class="tenantOption"
                v-for="option in tenants"
                v-bind:key="option"
                :value="{ value: option.value, text: option.text }"
              >{{ option.text ? option.text : option.value}}</option>
            </b-form-select>-->
          </b-form-group>

          <b-form-group class="permissionWrapper" label="Permissions" label-for="permissions-input"
            invalid-feedback="Please select a permission.">
              <treeselect 
                v-model="items" 
                :searchable="true"
                :clearable="true"
                :multiple="true" 
                :valueConsistsOf="'ALL'"
                @input="processSelection"
                :options="formattedPermissions">
              <div slot="before-list" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" style="padding: 15px; font-size: 12px; line-height: 15px; text-align: center;">
                Some permissions are shared across parents in the tree. Examples include a number of the video calling permissions and viewing patients / tasks. As a result some other nodes may partially select when selecting all of a parent branch.
              </div>
            </treeselect>
          </b-form-group>
        </b-form>
      </b-modal>
      <div v-if="showDeleteModal == true">
        <div class="areYouSureWrapper row m-0 align-items-center">
          <div class="popUpContent">
            <div class="popupHead">
              <span aria-hidden="true" @click="showDeleteModal = false">&times;</span>
            </div>
            <div class="popupBody">Are you sure you want to Delete Role?</div>
            <div class="popupFooter">
              <div class="yesBtn btn" @click.prevent="deleteRole($event), (showDeleteModal = false)">
                Yes
              </div>
              <div class="noBtn btn" @click="showDeleteModal = false">No</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-toast-notification/dist/theme-sugar.css";
import permissionsJson from "../assets/permissions.json";
import groupedPermissions from "../assets/new_permissions.json";
import { ModelSelect } from 'vue-search-select';
import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "Roles",
  components: { ModelSelect, Treeselect },
  data() {
    return {
      roles: [],
      selectedTenantName: "",
      selectedFilter: "",
      loading: true,
      errorMessage: "Loading...",
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      tenantsList: [],
      permissions: permissionsJson,
      formattedPermissions: groupedPermissions,
      lastSelectedTenant: "*",
      lastSelectedTenantObj: "*",
      permissionSelectedTenant: "",
      selectedRoles: [],
      permission1: "",
      showModal: false,
      showDeleteModal: false,
      filterString: "",
      items: [],
      roleName: "",
      roleDescription: "",
      editRoleName: "",
      editRoleDescription: "",
      rolesListEmpty:false
    };
  },
  mounted() {
    this.fetchData();
    this.fetchRoles();
    $("input").attr("autocomplete", "off");
    this.permissions.sort((a, b) => {
      return a.text.localeCompare(b.text)
    });

    this.formattedPermissions.sort((a, b) =>  {
      a.children.sort((a, b) => {
        a.label.localeCompare(b.label);
      });
      return a.label.localeCompare(b.label) 
    });
  },
  methods: {
    async onChanged() {
      this.clearSelection();
      this.$bvModal.hide("editModal");
      this.$bvModal.show("addModal");
    },
    editModal() {
      this.$bvModal.hide("editModal");
    },
    addModal() {
      this.$bvModal.hide("addModal");
    },
    async onEditChanged(role) {
      // this.clearSelection();
      this.editRoleName = role.name;
      this.editRoleDescription = role.description;
      this.permissionSelectedTenant = this.lastSelectedTenant;
      const set = new Set();
      this.formattedPermissions.forEach((parent) => {
        parent.children.forEach((child) => {
          if (role.permissions.includes(child.id)) { 
            set.add(child.id);
          }
        });
        if (parent.children.every(child => role.permissions.includes(child.id))) {
          set.add(parent.id);
        } else set.delete(parent.id);
      })
      this.items = Array.from(set);
      this.$bvModal.hide("addModal");
      this.$bvModal.show("editModal");
      this.disabledPermissions();
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    async changeTenantView() {
      this.selectedRoles = [];
      // this.roles = [];

      await this.fetchRoles();
    },
    async changepermissionTenantView() {
      this.selectedRoles = [];
    },
    async changePermissionView() {
      // var permissionText = this.permission1.text
      //  this.selectedRoles = [];
    },
    clearSelection() {
      this.roleName = "";
      this.roleDescription = "";
      this.items = [];
      this.disabledPermissions();
    },
    disabledPermissions() {
      this.permissions.forEach((e) => {
        if (this.items.length && this.items.indexOf(e.value) !== -1) {
          e.disabled = true;
        } else {
          e.disabled = false;
        }
      });
    },
    processSelection(data, instance) {
      const set = new Set();
      this.formattedPermissions.forEach((parent) => {
        parent.children.forEach((child) => {
          if (data.includes(child.id)) { 
            set.add(child.id);
          }
        });
        if (parent.children.every(child => data.includes(child.id))) {
          set.add(parent.id);
        } else set.delete(parent.id);
      })
      this.items = Array.from(set);
    },
    async fetchData() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      this.selectedRoles = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (tenantListResponse.status == 503) {
          return this.fetchData();
        }
        if (tenantListResponse.status != 200) {
          this.errorMessage = "Failed to get data";
        } else {
          var tenantsBody = await tenantListResponse.json();

          this.tenants = tenantsBody
            .map((t) => {
              return {
                text: t.text || t.value,
                id: t.value,
                value: t.value.toLowerCase().replace('-', ''),
              };
            })
            .sort((a, b) => {
              return a.text.localeCompare(b.text);
            });
          this.errorMessage = "";
          this.tenants.forEach((e) =>
            this.tenantsList.push({ value: e.value, text: e.text })
          );
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant list due to an error.";
        console.log("Failed to get tenant list", tex);
      }
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.changeTenantView();
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.id == tenant || e.name == tenant);
    },
    json2array(json) {
      var result = [];
      var keys = Object.keys(json);
      keys.forEach(function (key) {
        var arrObj = {};
        arrObj["name"] = key;
        for (var keyEle in json[key]) {
          arrObj[keyEle] = json[key][keyEle];
        }
        result.push(arrObj);
      });
      return result;
    },
    async fetchRoles() {
      this.roles=[]
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.rolesListEmpty=false;
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      if (this.lastSelectedTenant) {
        var role_list_request = new Request(
          config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/roles`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          }
        );
        try {
          var roleListResponse = await fetch(role_list_request);

          if (roleListResponse.status === 403) {
            this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
            return;
          }
          if (roleListResponse.status == 401) {
            this.errorMessage =
              "Your session has expired please login again to continue";

            return;
          }
          if (roleListResponse.status == 503) {
            return this.fetchRoles();
          }
          if (roleListResponse.status != 200) {
            this.errorMessage = "Failed to get data";
          } else {
            var rolesObj = await roleListResponse.json();
            var roles = this.json2array(rolesObj);

            // roles.forEach(e=>{
            //    let rolesNames = [];
            //   if( e.permissions && e.permissions.length){
            //       e.permissions.forEach(per=>{
            //         rolesNames.push(this.permissions.find(p=> p.value == per).text)
            //       })
            //       e["rolesNames"] = rolesNames;
            //   }

            // })
            this.roles = roles;
            if(this.roles.length==0)
            this.rolesListEmpty=true
          else
          this.rolesListEmpty=false
            this.errorMessage = "";
          }
        } catch (tex) {
          this.errorMessage = "Failed to get tenant roles due to an error.";
        }
        loader.hide();
      }
    },
    async addRole() {
      // debugger;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.IDENTITY_MANGER +
        `/tenants/${this.permissionSelectedTenant}/roles`;

      var tenants_list_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          name: this.roleName,
          description: this.roleDescription,
          permissions: this.items.filter((item) => !item.startsWith('parent-')),
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.addRole();
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to Add Role";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          //  var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully Added Role",
            type: "success",
          });
          this.fetchRoles();
        }
      } catch (tex) {
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async updateRole() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.IDENTITY_MANGER +
        `/tenants/${this.permissionSelectedTenant}/roles`;
      var tenants_list_request = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          name: this.editRoleName,
          description: this.editRoleDescription,
          permissions: this.items.filter((item) => !item.startsWith('parent-')),
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          Vue.$toast.open({ message: this.errorMessage, type: "error" });

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.updateRole();
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to update Role";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          // var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully Updated Role",
            type: "success",
          });
          this.fetchRoles();
        }
      } catch (tex) {
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async deleteRole(evt) {
      var o = evt.target;
      o.disabled = true;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var locUrl =
        config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/roles/`;
      var new_user_requeust = new Request(locUrl, {
        method: "DELETE",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          name: this.deletedRole,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(new_user_requeust);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.deleteRole(evt);
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to Delete Role";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          // var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully Deleted Role",
            type: "success",
          });
          this.fetchRoles();
        }
      } catch (tex) {
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },

    async addPermission() {
      this.items.push(this.permission1);
      this.disabledPermissions();
      this.permission1 = "";
    },
    async removePermission(item) {
      this.items.splice(item, 1);
      this.disabledPermissions();
      this.permission1 = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
select.form-control:hover,
textarea.form-control:hover {
  box-shadow: none;
  background: #fff;
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  color: #6a6a6a;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked~.checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}


.ui.selection.dropdown {
  border: none !important;

  i.dropdown.icon {
    display: none;
  }
}


.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 40px !important;
  margin-right: 40px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem>a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover>a,
.menuItem.active>a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics>span {
  position: relative;
  top: -1px;
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
}

.dashboardBlock {
  background: red;
  margin: 0 15px;
  padding: 30px;
  border-radius: 10px;
}

.dashboardIcon {
  float: left;
  margin-right: 20px;
}

.dashboardNumber {
  float: left;
  font-size: 45px;
  color: #fff;
  line-height: 1;
}

.dashboardNumber>span {
  font-size: 16px;
  display: block;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
      rgba(0, 192, 255, 1) 0%,
      rgba(0, 192, 255, 1) 35%,
      rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
      rgba(0, 255, 169, 1) 0%,
      rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
      rgba(31, 201, 253, 1) 0%,
      rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
      rgba(0, 255, 255, 1) 0%,
      rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
      rgba(254, 193, 148, 1) 0%,
      rgba(254, 168, 141, 1) 30%,
      rgba(254, 107, 125, 1) 50%,
      rgba(254, 8, 99, 1) 70%,
      rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 0 15px;
  background: #fff;
  width: 100%;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  margin: 0 15px 30px 15px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  max-width: calc((100vw / 7) - 35px);
  width: calc((100vw / 7) - 35px);
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 0 25px;
  font-size: 55px;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: center;
  padding: 10px 5px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 10px;
  align-items: center;
  text-overflow: ellipsis;
}

.pageHeader .filterWrapper .dropdown:before {
  border: solid #fff;
  border-width: 0 1px 1px 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background: transparent !important;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #f7f7f7;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #484848;
  padding: 0 15px;
  height: 40px;
  font-size:20px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #fff;
  color: #6a6a6a;
  padding: 10px 15px;
  justify-content: center;
  text-align: center;
  border-top: 1px solid #ebebeb;
}

.yesBtn,
.noBtn {
margin-right: 0;
border: none !important;
border-radius: 5px;
padding: 5px 10px !important;

min-width: 80px;
}
.yesBtn{
  background: #66BE6D !important;
}
.noBtn{
  background: #F27778 !important;
}
.yesBtn:hover{
  background: #3FAA48 !important;
}
.noBtn:hover{
  background: #E62829 !important;
}

.noBtn {
  margin-left: 15px;
  margin-right: 0px;
}


.modal-header {
  background: #50b9d4;
  color: #fff;
}

.test {
  font-size: 14px !important;
  color: #fff !important;
}

.modal-body {
  color: #7b7b7b;
}

.modal-body label {
  color: #1a80a8;
}

.modal-body .contentHeader>div.actionHeading {
  justify-content: center;
}

.actionHeading {
  max-width: 150px;
}

.modal-footer {
  background: #f2fdff;
  color: #1a80a8;
  justify-content: center;
}

.modal-footer .btn {
  padding: 5px 20px;
  border-radius: 6px;
  min-width: 100px;
  //border: 1px solid #50B9D4 !important;
}

.modal-footer .btn:hover {
  background: #fff;
  color: #50b9d4;
  cursor: pointer;
}

.modal-footer> :not(:last-child) {
  margin-right: 15px;
}

.modal-footer> :not(:first-child) {
  margin-left: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 5px;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
}

.filterDropDownData>a,
.actionDropDownData>a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData>a:hover,
.filterDropDownData>a.active,
.actionDropDownData>a:hover,
.actionDropDownData>a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.filterDropDownData>a::after,
.actionDropDownData>a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData>a:last-child::after,
.filterDropDownData>a.active::after,
.filterDropDownData>a:hover:after,
.actionDropDownData>a:last-child::after,
.actionDropDownData>a.active::after,
.actionDropDownData>a:hover:after {
  display: none;
}


.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}
#editModal___BV_modal_body_ .contentHeader{
  background:#eaf9ff;
}

.contentHeader>div {
  border-left: 1px solid #c7c7c7;
  display: inline-flex;
  align-items: center;
}

.contentHeader>div:first-child {
  border-left: 0px solid;
}

.contentDataWrapper {
  overflow: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 270px);
  min-height: calc(100vh - 270px);
  align-content: flex-start;
  padding-right:5px;
}

.contentData {
  background: #fff;
  color: #6a6a6a;
  height: auto;
  margin-top: 10px !important;
  cursor: pointer;
  min-height: 48px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData>div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}
.userContentWrapper .contentData > div{
  white-space:unset;
}

.contentData>div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
}

.deviceStatus {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  background: #66be6d;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  max-width: 200px;
  min-width: 200px;
}

.actionDropDown {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 140px;
  text-align: left;
}

.actionDropDown:after {
  right: 30px;
  position: absolute;
  top: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData>div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.deviceName>span {
  color: #50b9d4;
  padding-right: 15px;
}

.deviceDataWrapper .contentData {
  height: 80px;
}

.deviceDataWrapper .contentData>div:last-child {
  display: inline-flex;
  overflow: unset;
}

.pageHeader .importBtn{
  background: #575757;
}
.pageHeader .importBtn:hover{
  background: #1dd8f6;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 36px;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#3288D2;
}

.selectArea {
  max-width: 130px;
}

.userContentWrapper .contentData>div:first-child,
.userContentWrapper .contentData>div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData>div span {
  color: #6a6a6a;
  padding-right: 5px;
}

.btn {
  background: #1dd8f6;

  color: #fff;
  // position:absolute;
  // top:250px;
  // left:500px;
  border-color: #1dd8f6;
  padding: 5px 10px;
  border: 0px;
}

.userDetailContentHeader {
  background: #f2fdff;
  color: #1a80a8;
  font-size: 16px;
  height: 60px;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}

.userDetailContentHeader>div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem.disabled,
.buttonItem[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

a.buttonItem.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border:1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 20px !important;
  max-height: calc(100vh - 300px);
}

.userDemograpics {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #dceaea;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 20px;
}

.userDetails .col:last-child {
  padding-left: 20px;
}

.addBtn {
  border: 1px solid #dceaea;
  border-radius: 5px;
  padding: 7px 15px;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

.selectedItem>img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}

::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}


::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}



@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .dashboardIcon>img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 36px;
  }

  .dashboardNumber>span {
    font-size: 12px;
    display: block;
  }

  .facilityInfo .dashboardNumber {
    padding: 0 13px;
    font-size: 36px;
  }

  .facilityName {
    font-size: 14px;
  }

  .infoWrapper {
    padding: 10px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .actionDropDown {
    width: 125px;
  }

  .userContentWrapper .contentData>div:nth-child(2) .text-right {
    text-align: left !important;
  }

  .filterInputText {
    max-width: 215px !important;
    background: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
    padding: 0 0 0 4px !important;
  }
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 1px 15px;
}

#tenantConnectionId option {
  color: #6a6a6a;
}

.permissionWrapperSelect {
  width: 80% !important;
}

.permissionWrapper {

}

.permissionWrapper select {
  float: left;
  max-width: calc(100% - 40px);
}

.permissionWrapper img {
  width: 20px;
  display: inline-block;
  float: right;
  position: relative;
  top: 9px;
}

.permissionWrapper .btn {
  background: #ffffff !important;
  padding: 0px 10px 15px 9px !important;
  border: 0px !important;
}

#addModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#addModal___BV_modal_body_ {
  color: #1dd8f6;
}

.form-control {
  color: #6a6a6a;
}

#addModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

.modal-header {
  background-color: #f7f7f7;
  padding:12px 15px;
  align-items:center;
}

.permissionContentWrapper {
  max-height: 350px;
  overflow: hidden;
  overflow-y: auto;
}

.contentHeader>div.actionHeading {
  justify-content: center !important;
}

.btn .addBtn {
  background: #ffffff;
  padding: 0px 10px;
  border: 0px;
}

body select {
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: rgba(0, 0, 0, 0.3);
  color: #6a6a6a;
}
::v-deep .ui.search.dropdown .text {
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
}

::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}
h3 {
  padding: 20px 20px 0;
  color: #1a80a8;
  font-size: 24px;
  margin: 0;
  font-family: "GTWalsheimPro-Regular";
  font-weight: 400;
}

.role-attribute__small {
  font-size: smaller;
}


</style>

<style>
.add-role-modal .modal-dialog {
  max-width: 620px !important;
}
.vue-treeselect__checkbox--indeterminate {
  background: transparent;
  border-color: #e0e0e0;
}
.vue-treeselect__label-container:hover .vue-treeselect__checkbox--indeterminate {
  background: transparent;
  border-color: #039be5;
}
.vue-treeselect__minus-mark {
  opacity: 0 !important;
}
</style>